export default __webpack_public_path__ + "static/media/ipet01.36f879c0.png";